import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getClasificacionesFuncionales } from 'api/catalogos';

// eslint-disable-next-line react/prop-types
const ClasificacionesFuncionales = ({ permission }) => (
  <PlainCRUD
    title="Clasificaciones Funcionales"
    permission={permission}
    get={getClasificacionesFuncionales}
    fields={[
      defaultFields.clave,
      defaultFields.concepto,
    ]}
    readOnly
    tableProps={{ expandable: true }}
  />
);

export default ClasificacionesFuncionales;
